import { MessageTypeConstants } from "../../services/bot/Message";


export function formatMessageData(messageData) {
  if (!messageData) return null;

  const { messageId, contentType, createdOn, createdBy, content } = messageData;

  let formatted = {
    messageId: messageId || crypto.randomUUID(),
    contentType: contentType || '10',
    createdOn: createdOn || Date.now(),
    createdBy: createdBy || '',
    messageSent: true,
    modifiedOn: createdOn,
  };

  // IMAGE
  if (contentType === 'image' || contentType === '30') {
    const fileName = Array.isArray(content) && content.length ? content[0] : `${messageId || 'file'}.jpg`;
    formatted.content = [fileName];
    formatted.options = { fileName, type: 'image/jpeg' };

    // AUDIO
  } else if (contentType === 'audio' || contentType === '50') {
    const fileName = Array.isArray(content) && content.length ? content[0] : `${messageId || 'file'}.mp3`;
    formatted.content = [fileName];
    formatted.options = { fileName, type: 'audio/mp3' };

    // VIDEO
  } else if (contentType === 'video' || contentType === '40') {
    const fileName = Array.isArray(content) && content.length ? content[0] : `${messageId || 'file'}.mp4`;
    formatted.content = [fileName];
    formatted.options = { fileName, type: 'video/mp4' };

    // LOCATION
  } else if (contentType === 'location' || contentType === '290') {
    formatted.content = ['[Location]'];

    // STRING / TEXT
  } else if (contentType === 'string' || contentType === '10') {
    if (content && typeof content === 'object' && content.type === 'Buffer') {
      // decode buffer to text
      let data = content.data || content;
      if (Array.isArray(data)) data = new Uint8Array(data);
      if (data instanceof Uint8Array) {
        const decoded = new TextDecoder('utf-8').decode(data).trim();
        formatted.content = [decoded];
      } else {
        formatted.content = ['[Message]'];
      }
    } else if (typeof content === 'string' || Array.isArray(content)) {
      formatted.content = Array.isArray(content) ? content : [content];
    } else {
      formatted.content = ['[Message]'];
    }

    // OTHER / GENERIC FILES
  } else if (content && typeof content === 'object' && content.type === 'Buffer') {
    // treat as generic file
    const fileName = `${messageId || 'file'}.bin`;
    formatted.content = [fileName];
    formatted.options = { fileName, type: 'application/octet-stream' };

  } else {
    formatted.content = ['[Message]'];
  }

  return formatted;
}

function decodeBuffer(lastMessage) {
  try {
    if (!lastMessage) return '';

    if (lastMessage.type === 'Buffer') {
      let data = lastMessage.data;

      // handle nested buffer
      if (data && data.type === 'Buffer' && Array.isArray(data.data)) {
        data = data.data;
      }

      // convert to Uint8Array
      if (Array.isArray(data)) data = new Uint8Array(data);

      // decode to string
      if (data instanceof Uint8Array) {
        const decoded = new TextDecoder('utf-8').decode(data).trim();

        // try to parse JSON if possible
        if (decoded.startsWith('{')) {
          return JSON.parse(decoded);
        } else {
          // plain string (e.g. "asas")
          return { contentType: '10', content: [decoded] };
        }
      }
    }

    if (typeof lastMessage === 'object' && lastMessage !== null) {
      return lastMessage;
    }

    return '';
  } catch (err) {
    console.error('Buffer decode error:', err);
    return '';
  }
}


export const getLastMessageText = (lastMessage) => {
  try {
    const parsed = decodeBuffer(lastMessage);
    const contentType = parsed.contentType?.toString();

    switch (contentType) {
      case "10":
      case "150":
      case "string":
        return Array.isArray(parsed.content) ? parsed.content[0] : "[Message]";

      case "30":
      case "image":
        return "Image";

      case "40":
      case "video":
        return "Video";

      case "50":
      case "630":
      case "audio":
        return "Audio";

      case "300": case "310": case "320":
      case "330": case "340": case "350":
      case "file": case "pdf": case "1003":
        return "PDF";

      case "290":
      case "location":
        return "Location";

      case "530":
        return "[Card]";
      case MessageTypeConstants.MESSAGE_TYPE_STRING:
      case MessageTypeConstants.MESSAGE_TYPE_IMAGE:
      case "270": case "10": {
        const messageType = parsed.info?.messageType;
        const callType = parsed.info?.callType;

        const isVideo = callType === 'video';
        const isMissed = messageType === 'MISSED_CALL';

        if (isMissed) {
          return isVideo ? "Missed Video Call" : "Missed Voice Call";
        } else if (messageType) {
          return isVideo ? "Video Call" : "Voice Call";
        } else {
          return parsed.content;
        }
      }

      case "1000":
        return `Contact ${parsed?.userName || ''} added`;

      case "1001":
        return `Contact ${parsed?.userName || ''} invited`;

      default:
        return "";
    }
  } catch (err) {
    console.error("Failed to parse lastMessage", err, lastMessage);
    return '';
  }
};